import { axiosInstance } from '../axios';

const API_URL = '/api/user';

class UserService {
  async getUser() {
    return await axiosInstance.get(API_URL + '/currentUser');
  }

  async updateLocale(locale) {
    return await axiosInstance.post(API_URL + '/language/' + locale);
  }

  async getUsers(
    userProperty = 'email',
    valueOrder = 'DESC',
    limit = 5,
    offset = 0,
  ) {
    return await axiosInstance.get(
      API_URL +
        '/users' +
        `?userProperty=${userProperty}&valueOrder=${valueOrder}&limit=${limit}&offset=${offset}`,
    );
  }




  async findByName(searchTerm, mustIncludeIds){

    const params = new URLSearchParams();

    if (searchTerm !== null) {
      params.append('searchTerm', searchTerm);
    }
    if (mustIncludeIds){
      mustIncludeIds.forEach(id => {
        params.append('mustIncludeIds', id);
      });
    }

    const config = {
      params: params,
    };
    return axiosInstance.get(`${API_URL}/findUsers`, config);
  }
}

export default new UserService();
